import { useQuery } from "react-query";
import { getItemContent, Video } from "@/api/content.ts";

export const useVideo = (videoId?: number) => {
  return useQuery<Video>(
    ["video", videoId],
    () => {
      return getItemContent(videoId as number, "video");
    },
    {
      enabled: !!videoId,
    },
  );
};
